import {createFeatureSelector, createSelector} from '@ngrx/store';
import {State} from './destination.delete-many.reducer';
import {Destination} from '../../../services/api/destinations/destination.model';

export const deleteManyDestinationsFeatureKey = 'deleteManyDestinations';
export const featureSelector = createFeatureSelector<State>(deleteManyDestinationsFeatureKey);

export const getDeleteManyDestinationsRecord = createSelector(
  featureSelector,
  (state: State): Destination[] => state.record
);

export const getDeleteManyDestinationsLoaded = createSelector(
  featureSelector,
  (state: State): boolean => state.loaded
);

export const getDeleteManyDestinationsLoading = createSelector(
  featureSelector,
  (state: State): boolean => state.loading
);

export const getDeleteManyDestinationsError = createSelector(
  featureSelector,
  (state: State): any => state.error
);
